import React from 'react'

import styles from './Blocks.module.scss'

const Blocks = ({ children }) => <ul className={styles.blocks}>{children}</ul>

export default Blocks
